import { render } from "./dashboard-table.vue?vue&type=template&id=2921be1d&scoped=true&ts=true"
import script from "./dashboard-table.vue?vue&type=script&lang=ts"
export * from "./dashboard-table.vue?vue&type=script&lang=ts"

import "./dashboard-table.vue?vue&type=style&index=0&id=2921be1d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2921be1d"]])

export default __exports__